import { render } from "./leaves.vue?vue&type=template&id=172a8f8a"
import script from "./leaves.vue?vue&type=script&lang=js"
export * from "./leaves.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__